module.exports = __webpack_public_path__ + "static/img/2010@2x.32f57a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party/2010@2x.png
// module id = dFS8
// module chunks = 0